import React, { useEffect, useState } from "react";
import { useLocation, Navigate } from "react-router-dom";
import api from "@/lib/api";

export default function PageGuard({ children, slug }) {
  const loc = useLocation();
  const path = slug ? `/${slug}` : loc.pathname;
  const [blocked, setBlocked] = useState(false);

  useEffect(() => {
    let active = true;
    api.get("/website/pages").then(({ data }) => {
      const p = (data || []).find((x) => x.slug === path);
      if (active) setBlocked(!!(p && (p.active === false || p.published === false)));
    }).catch(() => {});
    return () => { active = false; };
  }, [path]);

  if (blocked) return <Navigate to="/" replace />;
  return children;
}
